// src/lib/EventTracker.tsx
import { createContext, useContext, useEffect, useMemo } from "react";
import { AvAnalytics } from "@availity/analytics-core";
import { jsx } from "react/jsx-runtime";
var EventTrackerContext = createContext(null);
var useEventTracker = () => {
  const ctx = useContext(EventTrackerContext);
  if (!ctx) {
    throw new Error("useEventTracker must be used within an EventTrackerProvider");
  }
  return ctx;
};
var EventTrackerProvider = ({
  children,
  plugins,
  pageTracking = true,
  autoTrack = true,
  recursive = true,
  attributePrefix = "data-analytics",
  eventModifiers = ["action"]
}) => {
  const analytics = useMemo(
    () => new AvAnalytics(plugins, Promise, pageTracking, autoTrack, { recursive, attributePrefix, eventModifiers }),
    [attributePrefix, autoTrack, eventModifiers, pageTracking, plugins, recursive]
  );
  useEffect(() => {
    analytics.init();
    if (pageTracking) {
      analytics.trackPageView();
    }
    return () => analytics.stopAutoTrack();
  }, [analytics, pageTracking]);
  return /* @__PURE__ */ jsx(EventTrackerContext.Provider, { value: analytics, children });
};
export {
  EventTrackerContext,
  EventTrackerProvider,
  useEventTracker
};
